import { put, takeLatest } from "redux-saga/effects";
import {
  create_city,
  edit_city,
  getCities,
  getOnlyStateCities,
  reOrderedCities,
  delete_city,
} from "../../auth/service";
import { cityActions } from "./CityReducer";

const {
  onGetCities,
  onGetOnlyStateCities,
  onUpdateCity,
  onCreateCity,
  onDeleteCity,
  onHandleCitySuccess,
  onHandleSpecificCitySuccess,
  onHandleCityError,
  onHandleSuccess,
  onCreateOneSuccess,
  onUpdateOneSuccess,
  onDeleteOneSuccess,
  onHandleError,
} = cityActions;

function* getCityRequest(action) {
  const res = yield getCities();
  if (!res.error && Array.isArray(res?.data)) {
    yield put(onHandleSuccess({ data: res?.data }));
  } else {
    console.log("get city error ", res.error);
    yield put(onHandleError(res));
  }
}

function* getOnlyStateCitiesRequest(action) {
  const res = yield getOnlyStateCities();
  if (!res.error && Array.isArray(res?.data)) {
    console.log("this is the data of only state cities", res?.data);
    yield put(onHandleCitySuccess({ data: res?.data }));
  } else {
    console.log("get state city error", res?.error);
    yield put(onHandleCityError(res));
  }
}

function* getSpecificCityDetails(action) {
  const res = yield getCities(action.payload);
  if (!res.error && Array.isArray(res?.data)) {
    yield put(onHandleSpecificCitySuccess({ data: res?.data[0] }));
  } else {
    console.log("get specific city error", res?.error);
    yield put(onHandleCityError(res));
  }
}

function* updateCityRequest(action) {
  const res = yield edit_city(action.payload);
  if (!res.error) {
    yield put(onUpdateOneSuccess({ data: res?.data }));
  } else {
    console.log("update city error ", res.error);
    yield put(onHandleError(res));
  }
}
function* createCityRequest(action) {
  const res = yield create_city(action.payload);
  if (!res.error) {
    yield put(onCreateOneSuccess({ data: res?.data }));
  } else {
    console.log("create city error ", res.error);
    yield put(onHandleError(res));
  }
}
function* deleteCityRequest(action) {
  const res = yield delete_city(action.payload);
  if (!res.error) {
    yield put(onDeleteOneSuccess({ data: res?.data }));
  } else {
    console.log("create city error ", res.error);
    yield put(onHandleError(res));
  }
}

function* citySaga() {
  yield takeLatest(onGetCities.type, getCityRequest);
  yield takeLatest(onUpdateCity.type, updateCityRequest);
  yield takeLatest(onCreateCity.type, createCityRequest);
  yield takeLatest(onDeleteCity.type, deleteCityRequest);
  yield takeLatest(onGetOnlyStateCities.type, getOnlyStateCitiesRequest);
  yield takeLatest(onHandleSpecificCitySuccess.type, getSpecificCityDetails);
}

export default citySaga;
